// @ts-nocheck
import styled from 'styled-components';
import GenericRenderContainerSection from './GenericRenderContainerSection';
import MobileSingleTopMatchRender from './TipiMatchBestFights/MobileSingleTopMatchRender';
import MobileDefaultTopMatchRender from './TipiMatchBestFights/MobileDefaultTopMatchRender';
import MobileTwoInSideTopMatchRender from './TipiMatchBestFights/MobileTwoInSideTopMatchRender';
import MobileThreeInSideTopMatchRender from './TipiMatchBestFights/MobileThreeInSideTopMatchRender';
import MobileTwoTagInSideTopMatchRender from './TipiMatchBestFights/MobileTwoTagInSideTopMatchRender';
import MobileHandicapTopMatchRender from './TipiMatchBestFights/MobileHandicapTopMatchRender';
import MobileNwoFiveOrSixMatchRender from './TipiMatchBestFights/MobileNwoFiveOrSixMatchRender';
import MobileThreeVsThreeMatchRender from './TipiMatchBestFights/MobileThreeVsThreeMatchRender';

const ContainerBestFights = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 15px;
    row-gap: 10px;
`;

function TopMatchWrestlerRender({ 
    bestFights,
    wrestlerId,
    wrestlerName,
    wrestlerAvatarPath
}) {
    const renderBestFight = (bestFight, key) => {
        switch (bestFight.type_match.type) {
            case 'single':
                return <MobileSingleTopMatchRender key={key} matchInfo={bestFight} />;
            case 'triple':
            case 'fatal':
            case 'tag':
                return <MobileTwoInSideTopMatchRender key={key} matchInfo={bestFight} />;
            case 'five':
            case 'six':
                return <MobileThreeInSideTopMatchRender key={key} matchInfo={bestFight} />;
            case 'three_tag':
            case 'four_tag':
                return <MobileTwoTagInSideTopMatchRender key={key} matchInfo={bestFight} />;
            case 'handicap':
                return <MobileHandicapTopMatchRender key={key} matchInfo={bestFight} />;
            case 'special':
                if (bestFight.type_match.name.toLowerCase().startsWith('nwo')) {
                    if(bestFight.wrestlers.length <= 6) {
                        return <MobileThreeInSideTopMatchRender key={key} matchInfo={bestFight} />;
                    } else {
                        return <MobileDefaultTopMatchRender 
                            key={key} 
                            matchInfo={bestFight} 
                            wrestlerId={wrestlerId}
                            wrestlerName={wrestlerName}
                            wrestlerAvatarPath={wrestlerAvatarPath}
                        />;
                    }
                } else if(bestFight.type_match.name.toLowerCase() == 'elimination chamber') {
                    return <MobileThreeInSideTopMatchRender key={key} matchInfo={bestFight} />;
                } else if (bestFight.type_match.name.toLowerCase() == '3 vs 3') {
                    return <MobileThreeInSideTopMatchRender key={key} matchInfo={bestFight} />;
                } else {
                    return <MobileDefaultTopMatchRender 
                        key={key} 
                        matchInfo={bestFight} 
                        wrestlerId={wrestlerId}
                        wrestlerName={wrestlerName}
                        wrestlerAvatarPath={wrestlerAvatarPath}
                    />;
                }
            default:
                return <MobileDefaultTopMatchRender 
                    key={key} 
                    matchInfo={bestFight} 
                    wrestlerId={wrestlerId}
                    wrestlerName={wrestlerName}
                    wrestlerAvatarPath={wrestlerAvatarPath}
                />;
        }
    }

    return (
        <GenericRenderContainerSection 
         className='top-match-wrestler-render'
         width="95%"
        >
            <p className='info-section info-top-match'>
                Selezione di 3 match casuali tra i più importanti della sua carriera. Cliccando sul match, si viene indirizzati al PPV.
            </p>

            <ContainerBestFights className='container-best-fights'>
                {bestFights.map((bestFight, key) => (
                    renderBestFight(bestFight, key)
                ))}
            </ContainerBestFights>
        </GenericRenderContainerSection>
    );
}

export default TopMatchWrestlerRender;  